import { Box, Button, createStyles, Text } from "@mantine/core";
import mixpanel from "mixpanel-browser";
import React from "react";
import { PopupButton } from "react-calendly";
import { useNavigate } from "react-router-dom";

const useStyles = createStyles((theme) => ({
  bannerContainer: {
    background: "#F5F5F5",
    borderRadius: 24,
    padding: "64px",
    marginInline: "auto",
    display: "flex",
    alignItems: "center",
    gap: 60,
    marginBottom: 120,
    "@media (max-width: 468px)": {
      padding: "30px 20px",
    },
  },
  text: {
    fontFamily: "Inter",
    fontSize: "24px",
    fontWeight: "600",
    color: "#262626",
    "@media (max-width: 768px)": {
      fontSize: "20px",
    },
    "@media (max-width: 468px)": {
      lineHeight: "30px",
      fontSize: "20px",
      fontWeight: "600",
      textAlign: "center",
    },
  },
  btns: {
    display: "flex",
    gap: "12px",
    justifyContent: "start",
    alignItems: "center",
    "@media (max-width: 435px)": {
      flexDirection: "column-reverse",
    },
  },
  demoBtn: {
    paddingLeft: "0",
    paddingRight: "0",
    height: "fit-content",
    background: "#FFF",
    borderRadius: 8,
    border: "1px solid #D0D5DD",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    "&:hover": {
      background: "#FFF",
      opacity: 0.8,
    },
  },
  createBtn: {
    borderRadius: 8,
    height: "fit-content",
    background: "#262626",
    border: "1px solid #262626",
    padding: "12px 20px",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    color: '#FFF',
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    "&:hover": {
      background: "#262626",
      opacity: 0.8,
    },
  },
  requestDemo: {
    width: "100%",
    border: "none",
    background: "none",
    padding: "12px 20px",
    cursor: "pointer",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
  },
  InlinePadding: {
    paddingInline: "6rem",
    paddingTop: 50,
    "@media (max-width: 768px)": {
      paddingInline: "3rem",
    },
    "@media (max-width: 430px)": {
      paddingInline: "1rem",
    },
  },
}));

const StartedBanner = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Box className={classes.InlinePadding}>
      <Box className={classes.bannerContainer}>
        <Text className={classes.text}>
          It’s easy to get started, with $0 onboarding fees and $0 training or
          setup fees.
        </Text>
        <Box className={classes.btns}>
          <Button
            size="md"
            width="180px"
            className={classes.demoBtn}
            onClick={() => mixpanel.track("demo booked")}
          >
            <PopupButton
              className={classes.requestDemo}
              url="https://calendly.com/ogiso-demo/30min?primary_color=ffba45"
              rootElement={document.getElementById("root")}
              text="Request Demo"
            />
          </Button>
          <Button
            size="md"
            width="180px"
            className={classes.createBtn}
            onClick={() => navigate("/signup")}
          >
            Create an account
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default StartedBanner;
